import {
  ContentText,
  ContentTariffs,
  ContentTextMedia,
  ContentMap,
  ContentRegistration,
  ContentMultiteaser,
  ContentOmq,
  ContentDivider,
  ContentVideo,
  ContentAccordion,
  ContentStage,
  ContentStageFullScreen,
  ContentImageSlider,
  ContentLocations,
  ContentContactForm,
  ContentButtonBanner,
  ContentBenefits,
} from '#components'

export default function useContentComponents(): Record<string, Component> {
  return {
    'content.text': ContentText,
    'content.tariffs': ContentTariffs,
    'content.textimage': ContentTextMedia,
    'content.map': ContentMap,
    'content.registration': ContentRegistration,
    'content.2-teaser': ContentMultiteaser,
    'content.3-teaser': ContentMultiteaser,
    'content.4-teaser': ContentMultiteaser,
    'content.teaser': ContentMultiteaser,
    'content.omq-faq': ContentOmq,
    'content.divider': ContentDivider,
    'content.video': ContentVideo,
    'content.accordion': ContentAccordion,
    'content.stage': ContentStage,
    'content.stage-full-screen': ContentStageFullScreen,
    'content.image-slider': ContentImageSlider,
    'content.locations': ContentLocations,
    'content.contact-form': ContentContactForm,
    'content.button-banner': ContentButtonBanner,
    'content.benefits-media': ContentBenefits,
  }
}
